<template>
  <footer class="footer">
    <div class=" footer__content">
      <div class="footer__content--logo">
        <a href="/">
          <SvgElement
            class="logo-svg"
            :name="iconName"
            color="white"
            width="169"
            height="63"
          />
        </a>

        <div class="social-media">
          <a
            v-if="$t('CITY.LINKS.facebook')"
            class="icon"
            :href="$t('CITY.LINKS.facebook')"
          >
            <SvgElement
              name="Facebook"
              width="38"
              height="38"
            />
          </a>
          <a
            v-if="$t('CITY.LINKS.linkedin')"
            class="icon"
            :href="$t('CITY.LINKS.linkedin')"
          >
            <SvgElement
              name="Linkedin"
              width="38"
              height="38"
            />
          </a>
          <a
            v-if="$t('CITY.LINKS.instagram')"
            class="icon"
            :href="$t('CITY.LINKS.instagram')"
          >
            <SvgElement
              name="Instagram"
              width="38"
              height="38"
            />
          </a>
          <a
            v-if="$t('CITY.LINKS.youtube')"
            class="icon"
            :href="$t('CITY.LINKS.youtube')"
          >
            <SvgElement
              name="Youtube"
              width="38"
              height="38"
            />
          </a>
        </div>
      </div>

      <div class="footer__content--menu">
        <a
          v-for="(link, index) in $t('CITY.LINKS.footerMenu')"
          :key="index"
          :href="link.link"
          target="_blank"
          rel="noopener noreferrer"
          class="link"
        >
          {{ link.name }}
        </a>
      </div>

      <div
        v-if="$t('CITY.NUMBER.local') || $t('CITY.NUMBER.other')"
        class="footer__content--contact"
      >
        <span class="phone__title">
          Telefone {{ $t('CITY.NUMBER.workingHours') }}:
        </span>
        <div
          v-if="$t('CITY.NUMBER.local')"
          class="phone__local"
        >
          <a
            class="phone__local__number"
            :href="$t('CITY.LINKS.localNo')"
          >
            <span>
              <SvgElement
                name="Telefone"
                width="13"
                height="13"
              />
              {{ $t('CITY.NUMBER.local') }}
            </span>
            <p class="phone__local__number--info">Munícipe</p>
          </a>

          <span
            v-if="$t('CITY.NUMBER.optional') || $t('CITY.NUMBER.other')"
            class="phone__local__separator"
          />

          <a
            v-if="$t('CITY.NUMBER.optional')"
            class="phone__local__number"
            :href="$t('CITY.LINKS.optional')"
          >
            <span>
              <SvgElement
                name="Telefone"
                width="13"
                height="13"
              />
              {{ $t('CITY.NUMBER.optional') }}
            </span>
            <p class="phone__local__number--info">Munícipe</p>
          </a>

          <a
            v-if="$t('CITY.NUMBER.other')"
            class="phone__local__number"
            :href="$t('CITY.LINKS.otherNo')"
          >
            <span>
              <SvgElement
                name="Telefone"
                width="13"
                height="13"
              />
              {{ $t('CITY.NUMBER.other') }}
            </span>
            <p class="phone__local__number--info">Outras localidades</p>
          </a>
        </div>
      </div>
    </div>

    <div class="footer__upcities">
      <SvgElement name="UpCities" />
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  computed: {
    iconName() {
      return `LogoPrefeitura${process.env.VUE_APP_KEYCLOAK_REALM === 'Uppersoft' ? 'upcities' : process.env.VUE_APP_KEYCLOAK_REALM}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.footer {
  color: $gray-500;
  background-color: $white;
  margin-bottom: 0;

  @include screen(phone-only) {
    margin-bottom: 4.325rem;
  }

  @media print {
    display: none;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    font-size: $text-sm;
    padding: 2rem 0 1.5rem;
    margin: 0 8%;
    border-bottom: $border-1 solid $gray-300;

    @include screen(tablet-big-up) {
      flex-direction: row;
      align-items: flex-start;
      gap: 1rem;
    }

    &--logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      max-width: 135px;

      @include screen(tablet-big-up) {
        align-items: flex-start;
      }

      .logo-svg {
        color: $white;
      }

      .social-media {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin-top: 1.5rem;

        .icon {
          width: 32px;
          height: 32px;
          background-color: $primary-light;
          color: $primary-light;
          border-radius: $radius-full;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 200ms ease-in-out;

          &:hover {
            box-shadow: 2px 3px 8px 0 rgba(0 0 0 / 0.2);
          }
        }
      }
    }

    &--menu {
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: 1rem;

      @include screen(tablet-big-up) {
        text-align: start;
        max-height: 140px;
        flex-wrap: wrap;
        column-gap: 3rem;
      }

      @include screen(desktop-up) {
        max-height: 95px;
      }
    }

    &--contact {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-evenly;
      align-items: center;
      gap: 1rem;
      width: 100%;
      padding: 0.75rem 0;
      border-top: $border-1 solid $gray-300;

      @include screen(tablet-big-up) {
        margin: 0;
        padding: 0;
        border: 0;
        width: fit-content;
        align-items: flex-start;
        flex-direction: column;
      }

      .phone {
        &__title {
          text-align: center;
          font-weight: $font-semibold;

          @include screen(tablet-big-up) {
            text-align: end;
          }
        }

        &__local {
          width: 100%;
          max-width: 310px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          gap: 0.5rem;
          flex-wrap: wrap;

          @include screen(tablet-big-up) {
            justify-content: flex-start;
          }

          &__number {
            display: flex;
            align-items: center;
            flex-direction: column;

            @include screen(tablet-big-up) {
              align-items: flex-start;
            }

            span {
              display: flex;
              align-items: center;
              gap: 0.35rem;
              font-size: 1rem;
              font-weight: $font-semibold;
            }

            &--info {
              font-size: $text-xs;
            }
          }

          &__separator {
            height: 42px;
            width: 2px;
            background-color: $gray-200;
            margin: 0 1rem;
          }
        }
      }
    }

    .link {
      &:hover {
        text-decoration: underline;
        color: $primary;
      }
    }
  }

  &__upcities {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0 1.5rem;

    @include screen(tablet-big-up) {
      padding: 0.75rem 0;
    }
  }
}
</style>
